// Formio Configuration to prevent CDN usage
// This file ensures Formio works completely offline without CDN dependencies

// Wait for Formio to be available
declare const Formio: any;

// Configure Formio immediately when it's loaded
if (typeof window !== 'undefined') {
  // Override any CDN-related configurations
  (window as any).FormioConfig = {
    cdn: null,
    base: '',
    icons: 'fontawesome',
    offline: true
  };

  // Intercept any attempts to load from CDN
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    if (typeof url === 'string' && url.includes('cdn.form.io')) {
      console.warn('Blocking CDN request to:', url);
      return Promise.reject(new Error('CDN requests are disabled for offline mode'));
    }
    return originalFetch.apply(window, args);
  };

  // Also intercept XMLHttpRequest
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method: string, url: string, ...rest: any[]) {
    if (url && url.includes('cdn.form.io')) {
      console.warn('Blocking CDN request to:', url);
      throw new Error('CDN requests are disabled for offline mode');
    }
    return originalOpen.apply(this, [method, url, ...rest]);
  };
}

// Export empty object to make this a module
export {};